// /src/components/AdobePageLoadTracker.js
'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function AdobePageLoadTracker() {
  const pathname = usePathname();

  useEffect(() => {
    // Check if effect is running on the page
    console.log(`Adobe Tracker: useEffect triggered for path: ${pathname}`);

    const pushPageLoadEvent = () => {
      // Check if the adobeDataLayer exists right before we try to use it.
      if (typeof window.adobeDataLayer !== 'undefined' && Array.isArray(window.adobeDataLayer)) {
        console.log("Adobe Tracker: Found adobeDataLayer. Preparing to push event.");
        
        const pageName = `www:getserious:${pathname === '/' ? 'home' : pathname.replace('/', '')}`;

        window.adobeDataLayer.push({
          event: 'page-loaded',
          pageInfo: {
            pageName: pageName
          }
        });
        
        // Confirm page load event
        console.log(`Adobe Tracker: SUCCESS! Fired page-loaded event for pageName: ${pageName}`);

      } else {
        // Report load failure
        //console.error("Adobe Tracker: FAILED! adobeDataLayer was not found on the window object.");
      }
    };

    // Use a timeout to give the main Adobe script a moment to initialize.
    const timer = setTimeout(() => {
      pushPageLoadEvent();
    }, 500); // 500ms delay

    return () => clearTimeout(timer);

  }, [pathname]);

  return null;
}